import { Component, inject } from '@angular/core';
import { PropertyTypeRegionParameterService } from 'orchestrator';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  PropertyTypeRegionParameterCreateDto,
  PropertyTypeRegionParameterDto,
  PropertyTypeRegionParameterExcelDownloadDto,
  PropertyTypeRegionParameterUpdateDto,
} from '../proxy/controlling/dtos/property-type-region-parameter';
import { PROPERTYTYPEREGIONPARAMETER_CONFIG, PROPERTYTYPEREGIONPARAMETER_FIELDS } from './property-type-region-parameter.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-property-type-region-parameter',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, PropertyTypeRegionParameterService, ConfirmationService],
  templateUrl: './property-type-region-parameter.html',
  styleUrl: './property-type-region-parameter.scss',
})
export class PropertyTypeRegionParameter extends BaseCrudComponent<
  PropertyTypeRegionParameterDto,
  PropertyTypeRegionParameterCreateDto,
  PropertyTypeRegionParameterUpdateDto,
  PropertyTypeRegionParameterExcelDownloadDto
> {
  service = inject(PropertyTypeRegionParameterService);
  config = PROPERTYTYPEREGIONPARAMETER_CONFIG;
  fields = PROPERTYTYPEREGIONPARAMETER_FIELDS;

  protected prepareUpdateDto(data: any, selected: PropertyTypeRegionParameterDto): PropertyTypeRegionParameterUpdateDto {
    return {
      propertyTypeId: data.propertyTypeId,
      serviceMasterId: data.serviceMasterId,
      isDirectActivity: data.isDirectActivity,
      costCenterId: data.costCenterId,
      sapDocumentTypeId: data.sapDocumentTypeId,
      profitCenterId: data.profitCenterId,
      accountId: data.accountId,
      contractTypeId: data.contractTypeId,
      internalOrderId: data.internalOrderId,
      regionId: data.regionId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'PropertyTypeRegionParameter';
  }
}
